import request from "../utils/request";

// 获取岗位类别
export function getPositionType(data) {
  return request({
    url: "?s=Web.CompanyWebsite_Recruitment.GetPositionType",
    method: "post",
    data
  });
}

// 获取岗位列表
export function getPositionList(data) {
  return request({
    url: "?s=Web.CompanyWebsite_Recruitment.GetPositionList",
    method: "post",
    data
  });
}
